import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../..../../../store/state/app.state';
import { UtilService, SERVICE_END_POINT, AnalyticsService, DataMapperService } from 'src/app/shared';
import { AlertModal } from 'src/app/model/alert';
import { PersonalDetails, RefNo, RegistrationDetails, YourPersonalDetails } from 'src/app/model/ngrx';
import { MEDICAL_UW_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import * as UserDataConfig from '../../pages/user-details/config/user-data.config';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { ModalComponent } from '../modal/modal.component';
import { ButtonComponent } from '../../form-elements/button/button.component';
import { NgClass } from '@angular/common';


@Component({
    selector: 'app-content-bottom-nav',
    templateUrl: './content-bottom-nav.component.html',
    styleUrls: ['./content-bottom-nav.component.scss'],
    imports: [NgClass, ButtonComponent, ModalComponent]
})

export class ContentBottomNavComponent implements OnInit, OnDestroy {
  @Input() userInputDetail;
  @Input() buttonType;
  @Input() disabled;
  @Input() checkData;
  @Input() editMode;
  @Input() isloading;
  // tslint:disable-next-line:no-output-on-prefix
  @Output() nextHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() logInHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() registerHandler: EventEmitter<any> = new EventEmitter<any>();
  public contentData;
  protected cmsProductChoice: object;
  protected productCms: object;
  protected playbackList = [];
  public cmsDataProductChoice: any;
  public productsChoice: any;
  protected selectedProduct: any;
  public selectedProductCode: string;
  public productsChoiceStore: Observable<any[]>;
  public userForm: UntypedFormGroup;
  youroptionscalculation: boolean;
  public CMSData;
  public isLocked: boolean;
  screenName;
  public lockedAlertModalConfig: AlertModal;
  referenceNumberStore: Observable<RefNo[]>;
  referenceNumber: RefNo;
  personalDetailsStore: Observable<PersonalDetails[]>;
  yourPersonalDetailsStore: Observable<YourPersonalDetails[]>;
  personData:any;
  yourPersonData;
  skipLabel: any;
  subappstore: Subscription;
  private responseApplicationData: any[];
  isHOView: boolean;
  isApplyJourney: boolean;
  @Output() skipBtnHandler: EventEmitter<any> = new EventEmitter<any>();
  public buttonDetail = UserDataConfig.ElementsConfig;
  private loginButtonDetail =  {
    ...UserDataConfig.ElementsConfig.regsiterbuttonConfig,
    name: 'log_in',
    label: 'Log in',
  }
  public loginDetail: any;

  constructor(private fb: UntypedFormBuilder, public router: Router, private route: ActivatedRoute, 
    private store: Store<AppState>, private utilService: UtilService,
    private analyticsService: AnalyticsService) {
    this.contentData = this.route.snapshot.data.contentData;
    this.cmsProductChoice = this.route.snapshot.data.contentData.pleaseConfirmDetails;
    this.playbackList = this.route.snapshot.data.contentData.pleaseConfirmDetails.playBack;
    this.cmsDataProductChoice = this.route.snapshot.data.contentData.productChoice;
    this.productsChoiceStore = this.store.select(STORE_VAL.quote_capture);
    this.productsChoiceStore.subscribe(res => {
      if (res.length > 0) {
        this.productsChoice = res[0];
      }
    });
    this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
    this.personalDetailsStore = this.store.select(STORE_VAL.personal_details);
    this.yourPersonalDetailsStore = this.store.select(STORE_VAL.your_personal_details);
    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
        }
    });

    this.personalDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        let customerAge =  (val[0].dateOfBirth!='' &&  val[0].dateOfBirth !=null) ? val[0].dateOfBirth : '' ;
        let totalAge;
        if(customerAge) {
          totalAge  = (new Date().getFullYear()) - (Number(customerAge.split('/')[2]))
        }
        this.personData =  { 
                             'age': (totalAge) ? totalAge : '',
                             'dateOfBirth': val[0].dateOfBirth, 
                             'gender': (val[0].gender && val[0].gender == 'M') ? 'Male': 'Female', 
                             'postcode': val[0].postcode, 
                             'email': val[0].emailAddress,
                             'forename': val[0].forename,
                             'surname': val[0].surname,
                             'mobilePhone': val[0].mobilePhone,
                             'homePhone': val[0].homePhone,
                             'quoteEmail': (val[0].internalSoftOptInInd == 'Y') ? 'Y' : 'N'

                            }
        }
    });

    this.yourPersonalDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        let customerAge =  (val[0].dateOfBirth!='' &&  val[0].dateOfBirth !=null) ? val[0].dateOfBirth : '' ;
        let totalAge;
        if(customerAge) {
          totalAge  = (new Date().getFullYear()) - (Number(customerAge.split('/')[2]))
        }
        this.yourPersonData =  { 
                             'age': (totalAge) ? totalAge : '',
                             'dateOfBirth': val[0].dateOfBirth, 
                             'gender': (val[0].gender && val[0].gender == 'M') ? 'Male': 'Female', 
                             'postcode': val[0].address.postcode, 
                             'email': val[0].emailAddress,
                             'forename': val[0].forename,
                             'surname': val[0].surname,
                             'mobilePhone': val[0].mobilePhone,
                             'homePhone': val[0].homePhone,
                             'quoteEmail':  val[0].internalSoftOptInInd,

                            }
        }
    });

    this.subappstore = this.store.select(STORE_VAL.application_data_response).subscribe((val) => {
      if (val && val.length > 0) {
        this.responseApplicationData = val[0];
      }
    });

    if (this.responseApplicationData && this.responseApplicationData['triggeredBy'] === 'HOuser') {
    this.isApplyJourney = this.router.url.includes('apply') ? true : false;
    }
    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetail = res[0];
      }
    });
    this.isHOView = this.router.url.includes('ho-underwriting') ? true : false;
  }

  ngOnDestroy() {
    if (this.subappstore) {
      this.subappstore.unsubscribe();
    }
  }


  ngOnInit() {
    this.CMSContentMapper();
    this.lockedAlertModalConfig = this.contentData['modalConfigLocked']; // CMS 
    if (this.productsChoice && this.productsChoice.product) {
      this.selectedProduct = this.cmsDataProductChoice.products.find(p => p.productCode === this.productsChoice['product']).productName;
      this.selectedProductCode = this.cmsDataProductChoice.products.find(p => p.productCode === this.productsChoice['product']).productCode;
    }
    this.userFormData();
  }


  userFormData = () => {
    this.userForm = this.fb.group({
      next: ['']
    });
  }
  goNextPage = () => {
    let pageName: string;
    let isHoUser: boolean;

    switch(this.router.url) {
      case '/apply/your-product-application' : 
            pageName = 'submit application';
            break;
      case '/apply/congratulations' :
            pageName = 'back to my quotes';
            break;
      case '/home/before-you-start' :
            pageName = 'Complete initial risk questions';
            break;
      case '/home/your-personal-details' : 
            pageName = 'Enter personal details';
            break;
      case '/quote/please-confirm-your-details' : 
            pageName = 'Get your quote';
            break;

      default: pageName = 'Next';
    }

    isHoUser = ( this.isApplyJourney || this.isHOView ) ? true : false;
    this.analyticsService.eventTrack({type: 'ButtonClick', name: pageName, pageID: this.getCurrentScreenURL()});    
    let customerAge = (this.loginDetail?.customer?.dateOfBirth != '' && this.loginDetail?.customer?.dateOfBirth != null) ? this.loginDetail?.customer?.dateOfBirth : '';
    const personData = DataMapperService.mapCustomerToPersonData(this.loginDetail, customerAge);
    if(this.router.url.includes('apply')){
      this.analyticsService.customerTrack({...personData, referenceId: this.getRefNo() ,agent: isHoUser, ...this.yourPersonData});
    } else  {
      this.analyticsService.customerTrack({ ...personData, referenceId: this.getRefNo() ,agent: isHoUser});
    }
    this.analyticsService.orderTrack({ internalReferenceDCJ: this.referenceNumber?.quoteReferenceNumber, applicationReferenceDCJ:this.referenceNumber?.applicationRefNumber});
    if ( this.router.url === MEDICAL_UW_URL.annuitant.lifestyle || this.router.url === MEDICAL_UW_URL.dependant.dependantLifestyle) {
      this.utilService.isQuoteLocked(this.referenceNumber ? this.referenceNumber?.quoteReferenceNumber : null).subscribe(
        res => {
          if (res) {
            this.isLocked = true;
          } else {
            this.isLocked = false;
            this.nextHandler.emit();
          }
        });
    } else {
      this.nextHandler.emit();
     }
  }
  
  getRefNo() {
    return  this.referenceNumber ? this.referenceNumber?.quoteReferenceNumber : null;
  }

  navToDependant(): void {
    this.analyticsService.eventTrack({type: 'ButtonClick', name: 'Skip', pageID: this.getCurrentScreenURL()});
    this.skipBtnHandler.emit();
  }
  
  closeLockedModal() {
    this.isLocked = false;
  }
  /** Code block for CMS */
  CMSContentMapper() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_ToGetAQuoteYouWillNeed;
    this.utilService.getCMSData(URL).subscribe(res => {
      this.CMSData = res;
      /** This method should only be called once CMSData != null */
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData.contentBottomNavigationBar.approxQuotationTime = this.CMSData.string_QuoteCompletionDuration;
      if (this.router.url === '/home/medical-conditions' || this.router.url === '/home/dependant-medical-conditions' || 
          this.router.url === '/ho-underwriting/dependant-medical-conditions') {
              this.skipLabel = this.CMSData.commonBlock.string_SkipCTALabel;
          }
      }
  });
}
/** End of code block for CMS */
/** For web tracking */
getCurrentScreenURL() {
  this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
  return this.screenName;
}

onlogin = () => { this.logInHandler.emit(); }
onRegister = () => { this.registerHandler.emit(); }

}
